<template>
    <swiper :modules="modules" :slides-per-view="3" :space-between="30" :loop="true"
        :autoplay="{ delay: 3000, disableOnInteraction: false }" :pagination="{ clickable: false }" :navigation="false"
        class="mySwiper">
        <swiper-slide v-for="(program, index) in programs" :key="index">
            <div class="bd-program-2 clr-2">
                <div class="bd-program-thumb-wrapper">
                    <a :href="program.link">
                        <div class="bd-program-thumb-2">
                            <img :src="program.image" :alt="program.title" />
                        </div>
                    </a>
                </div>
                <div class="bd-program-content mb-10">
                    <h3 class="bd-program-title">
                        <a :href="program.link" class="hover-clr-2">{{ program.title }}</a>
                    </h3>
                </div>
                <div class="bd-program-info-wrapper-2">
                    <div class="bd-program-info" v-for="(info, idx) in program.infos" :key="idx">
                        <h5 class="bd-program-info-title">
                            {{ info.value }} <br /><span>{{ info.label }}</span>
                        </h5>
                    </div>
                </div>
            </div>
        </swiper-slide>
    </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        return {
            modules: [Autoplay, Navigation, Pagination],
        };
    },
    data() {
        return {
            programs: [
                {
                    title: 'Class - Play Group to II',
                    link: 'pre_primary.html',
                    image: '/img/home/c1.png',
                    infos: [
                        { value: '3-7 Yrs', label: 'age' },
                        { value: '6 Days', label: 'weekly' },
                        { value: '5 Hrs', label: 'period' },
                    ],
                },
                {
                    title: 'Class - III to V',
                    link: 'primary.html',
                    image: '/img/home/c2.png',
                    infos: [
                        { value: '8-11 Yrs', label: 'age' },
                        { value: '6 Days', label: 'weekly' },
                        { value: '6 Hrs', label: 'period' },
                    ],
                },
                {
                    title: 'Class - VI to VIII',
                    link: 'secondary.html',
                    image: '/img/home/c3.png',
                    infos: [
                        { value: '11-13 Yrs', label: 'age' },
                        { value: '6 Days', label: 'weekly' },
                        { value: '6 Hrs', label: 'period' },
                    ],
                },
                {
                    title: 'Class - IX to XII',
                    link: 'senior_secondary.html',
                    image: '/img/home/c4.png',
                    infos: [
                        { value: '14-17 Yrs', label: 'age' },
                        { value: '6 Days', label: 'weekly' },
                        { value: '6 Hrs', label: 'period' },
                    ],
                },
            ],
        };
    },
};
</script>

<style>
.swiper-pagination {
    bottom: -20px !important;
    /* move it lower (more space below) */
    position: absolute;
}
</style>